(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var style = document.createElement('style');
  style.textContent =
    '.grid__item .card-wrapper{opacity:0;transform:translateY(24px);transition:opacity .7s cubic-bezier(.2,0,.1,1),transform .7s cubic-bezier(.2,0,.1,1);}' +
    '.grid__item .card-wrapper.form-in{opacity:1;transform:none;}';
  document.head.appendChild(style);

  function init() {
    var cards = document.querySelectorAll('.grid__item .card-wrapper');
    if (!('IntersectionObserver' in window) || !cards.length) {
      cards.forEach(function (c) { c.classList.add('form-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var idx = Array.prototype.indexOf.call(e.target.parentNode.parentNode.children, e.target.parentNode) % 4;
          e.target.style.transitionDelay = (idx * 80) + 'ms';
          e.target.classList.add('form-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    cards.forEach(function (c) { io.observe(c); });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
